import { render } from "./PostInvoiceReasons.vue?vue&type=template&id=38497a38"
import script from "./PostInvoiceReasons.vue?vue&type=script&lang=js"
export * from "./PostInvoiceReasons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__